import { render, staticRenderFns } from "./employee-fnnfiled.vue?vue&type=template&id=63a537f4&scoped=true&"
import script from "./employee-fnnfiled.vue?vue&type=script&lang=js&"
export * from "./employee-fnnfiled.vue?vue&type=script&lang=js&"
import style0 from "./employee-fnnfiled.vue?vue&type=style&index=0&id=63a537f4&prod&scoped=true&lang=css&"
import style1 from "./employee-fnnfiled.vue?vue&type=style&index=1&id=63a537f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a537f4",
  null
  
)

export default component.exports